import { depsEqual } from '@utils/depsEqual'
import { useRef, type DependencyList, useEffect, type useLayoutEffect } from 'react'

type EffectHookType = typeof useEffect | typeof useLayoutEffect
type CreateUpdateEffect = (hook: EffectHookType) => EffectHookType

const createDeepCompareEffect: CreateUpdateEffect = hook => (effect, deps) => {
  const ref = useRef<DependencyList>(undefined)
  const signalRef = useRef<number>(0)

  if (deps === undefined || !depsEqual(deps, ref.current)) {
    signalRef.current += 1
  }
  ref.current = deps

  hook(effect, [signalRef.current])
}
export const useDeepCompareEffect = createDeepCompareEffect(useEffect)
